import React, { useEffect } from 'react';
import { isBlank } from 'utils/helperMethods';
import { head } from 'ramda';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@material-ui/core';
import MortgageSurveyQuestionPresenter from 'presenters/MortgageSurveyQuestionPresenter';
import InputWithSlider from 'sharedComponents/InputWithSlider';
import MortgageSurveyPresenter from 'presenters/MortgageSurveyPresenter';

import useStyles from './useStyles';

const WARNING_INCOME_MORTGAGE_RATIO = 5.1102373093;
const DISABLE_INCOME_MORTGAGE_RATIO = 7.5;
const DEFAULT_VALUE_PRICE_TARGET_RATIO = 1 / 3;

const AnnualGrossIncomeQuestion = props => {
  const { question, onChange, surveyValues, onValidate, initialPassing } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const field = head(MortgageSurveyQuestionPresenter.surveyValueFields(question));
  const currentValue = MortgageSurveyPresenter[field](surveyValues);
  const options = MortgageSurveyQuestionPresenter.options(question);
  const { min, max, marksDivider } = options;
  const priceTarget = MortgageSurveyPresenter.priceTarget(surveyValues);
  const downPaymentTarget = MortgageSurveyPresenter.downPaymentTarget(surveyValues);
  const shouldShowWarning = currentValue < (priceTarget - downPaymentTarget) / WARNING_INCOME_MORTGAGE_RATIO;

  useEffect(() => {
    if (!initialPassing) return;
    const defaultValue = Math.round((priceTarget * DEFAULT_VALUE_PRICE_TARGET_RATIO) / 1000) * 1000;
    onChange([{ field, value: defaultValue }]);
  }, []);

  useEffect(() => {
    const isValid =
      !isBlank(currentValue) &&
      !(currentValue < (priceTarget - downPaymentTarget) / DISABLE_INCOME_MORTGAGE_RATIO) &&
      currentValue >= 0;
    onValidate(isValid);
  }, [currentValue]);

  const handleValueChange = value => {
    onChange([{ field, value }]);
  };

  return (
    <Box width="100%">
      <Typography variant="h1">{MortgageSurveyQuestionPresenter.label(question)}</Typography>
      <Box mt={2} />
      <Typography variant="body1">{MortgageSurveyQuestionPresenter.description(question)}</Typography>
      <Box mt={4} />
      <InputWithSlider
        className={classes.input}
        value={currentValue}
        min={min}
        max={max}
        marksDivider={marksDivider}
        label={MortgageSurveyQuestionPresenter.inputLabel(question)}
        onChange={handleValueChange}
      />
      {shouldShowWarning && (
        <Box width="100%" className={classes.warning} mt={1} p={2}>
          <Typography variant="body1" color="inherit" className={classes.warningHeader}>
            {t('components.MortgageSurvey.AnnualGrossIncomeQuestion.warning')}
          </Typography>
          <Box mt={2} />
          <Typography variant="body2">
            {t('components.MortgageSurvey.AnnualGrossIncomeQuestion.warningText')}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

AnnualGrossIncomeQuestion.propTypes = {
  question: MortgageSurveyQuestionPresenter.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  surveyValues: MortgageSurveyPresenter.shape().isRequired,
  onValidate: PropTypes.func.isRequired,
  initialPassing: PropTypes.bool.isRequired,
};

export default AnnualGrossIncomeQuestion;



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/AnnualGrossIncomeQuestion/AnnualGrossIncomeQuestion.js